var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable no-underscore-dangle */
import create from 'zustand';
import { persist } from 'zustand/middleware';
import { SettingsToolTypes } from './types';
export const defaultConfigurableSettings = {
    routePriority: 'RECOMMENDED',
    slippage: '0.5',
};
export const defaultSettings = {
    appearance: 'auto',
    gasPrice: 'normal',
    advancedPreferences: false,
    showDestinationWallet: true,
};
export const useSettingsStore = create()(persist((set) => (Object.assign(Object.assign({}, defaultSettings), { setValue: (key, value) => set(() => ({
        [key]: value,
    })), setValues: (values) => set((state) => {
        const updatedState = Object.assign({}, state);
        for (const key in values) {
            if (Object.hasOwn(state, key)) {
                updatedState[key] = values[key];
            }
        }
        return updatedState;
    }), initializeTools: (toolType, tools) => {
        if (!tools.length) {
            return;
        }
        set((state) => {
            const updatedState = Object.assign({}, state);
            if (updatedState[`_enabled${toolType}`]) {
                // Add a new tools
                const enabledTools = tools
                    .filter((tool) => !Object.hasOwn(updatedState[`_enabled${toolType}`], tool))
                    .reduce((values, tool) => {
                    values[tool] = true;
                    return values;
                }, updatedState[`_enabled${toolType}`]);
                // Filter tools we no longer have
                updatedState[`_enabled${toolType}`] = Object.fromEntries(Object.entries(enabledTools).filter(([key]) => tools.includes(key)));
            }
            else {
                updatedState[`_enabled${toolType}`] = tools.reduce((values, tool) => {
                    values[tool] = true;
                    return values;
                }, {});
            }
            updatedState[`enabled${toolType}`] = Object.entries(updatedState[`_enabled${toolType}`])
                .filter(([_, value]) => value)
                .map(([key]) => key);
            return updatedState;
        });
    }, setTools: (toolType, tools, availableTools) => set(() => ({
        [`enabled${toolType}`]: tools,
        [`_enabled${toolType}`]: availableTools.reduce((values, tool) => {
            values[tool.key] = tools.includes(tool.key);
            return values;
        }, {}),
    })) })), {
    name: 'li.fi-widget-settings',
    version: 2,
    partialize: (state) => {
        const { enabledBridges, enabledExchanges } = state, partializedState = __rest(state, ["enabledBridges", "enabledExchanges"]);
        return partializedState;
    },
    merge: (persistedState, currentState) => {
        const state = Object.assign(Object.assign({}, currentState), persistedState);
        SettingsToolTypes.forEach((toolType) => {
            state[`enabled${toolType}`] = Object.entries(persistedState[`_enabled${toolType}`])
                .filter(([_, value]) => value)
                .map(([key]) => key);
        });
        return state;
    },
    migrate: (persistedState, version) => {
        if (version === 0 && persistedState.appearance === 'system') {
            persistedState.appearance = defaultSettings.appearance;
        }
        if (version === 1) {
            persistedState.slippage = defaultConfigurableSettings.slippage;
        }
        return persistedState;
    },
}));
export const setDefaultSettings = (config) => {
    var _a, _b, _c, _d, _e;
    const { slippage, routePriority, setValue } = useSettingsStore.getState();
    const defaultSlippage = ((config === null || config === void 0 ? void 0 : config.slippage) ||
        ((_b = (_a = config === null || config === void 0 ? void 0 : config.sdkConfig) === null || _a === void 0 ? void 0 : _a.defaultRouteOptions) === null || _b === void 0 ? void 0 : _b.slippage) ||
        0) * 100;
    const defaultRoutePriority = (config === null || config === void 0 ? void 0 : config.routePriority) || ((_d = (_c = config === null || config === void 0 ? void 0 : config.sdkConfig) === null || _c === void 0 ? void 0 : _c.defaultRouteOptions) === null || _d === void 0 ? void 0 : _d.order);
    if (!slippage) {
        setValue('slippage', (_e = (defaultSlippage || defaultConfigurableSettings.slippage)) === null || _e === void 0 ? void 0 : _e.toString());
    }
    if (!routePriority) {
        setValue('routePriority', defaultRoutePriority || defaultConfigurableSettings.routePriority);
    }
};
